// recoil/authState.ts
import { atom } from "recoil";

export interface AuthState {
  userId: string | null;
  role: "user" | "admin" | null;
}

export const authState = atom<AuthState>({
  key: "authState",
  default: {
    userId: null,
    role: null,
  },
});
